import { Close } from '@drift-labs/icons';
import { NotificationToastItem } from './types';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import useSafePush from 'src/hooks/useSafePush';

interface NotificationToastProps {
	item: NotificationToastItem;
	onDismiss: () => void;
}

export default function NotificationToast({
	item,
	onDismiss,
}: NotificationToastProps) {
	const showDrawer = useDrawersStore((s) => s.showDrawer);
	const safePush = useSafePush();

	const handleClick = () => {
		if (item.ctaRoute) {
			safePush(item.ctaRoute);
		} else {
			showDrawer('notifications');
		}
		onDismiss();
	};

	const handleCloseClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		onDismiss();
	};

	return (
		<div
			className="flex w-80 cursor-pointer items-center gap-sm rounded-sm border border-purple-bg bg-button-secondary-bg-hover p-lg shadow-sm"
			onClick={handleClick}
		>
			<ToastIcon icon={item.icon} />
			<div className="flex flex-1 flex-col gap-md">
				<div className="flex items-start gap-xs">
					<p className="flex-1 typo-t4 text-text-default">{item.title}</p>
					<button onClick={handleCloseClick}>
						<Close size={16} />
					</button>
				</div>
			</div>
		</div>
	);
}

function ToastIcon({ icon }: { icon: NotificationToastItem['icon'] }) {
	const className = 'size-xl shrink-0';

	switch (icon) {
		case 'success':
			return (
				<div
					className={`${className} flex items-center justify-center rounded-full bg-positive-green`}
				>
					<span className="typo-b5 text-white">&#10003;</span>
				</div>
			);
		case 'warning':
			return (
				<div
					className={`${className} flex items-center justify-center rounded-full bg-warn-orange`}
				>
					<span className="typo-b5 text-white">!</span>
				</div>
			);
		case 'market':
			return (
				<div
					className={`${className} flex items-center justify-center rounded-full bg-purple-bg`}
				>
					<span className="typo-b5 text-white">&#9733;</span>
				</div>
			);
		case 'info':
		default:
			return (
				<div
					className={`${className} flex items-center justify-center rounded-full bg-button-secondary-bg`}
				>
					<span className="typo-b5 text-text-default">i</span>
				</div>
			);
	}
}
